import { useListWorkspaceFlowRuns } from '@reelplicate/api-client/flow-runs';
import { useListWorkspaces } from '@reelplicate/api-client/workspaces';

import { isOpen } from '../editor/run/run-state';

/** How often the count is checked: often while something runs, else now and then (schedules start runs too). */
const BUSY_POLL_MS = 5_000;
const IDLE_POLL_MS = 30_000;

/** How many of the workspace's runs are still going - the sidebar's Running count. */
export function useRunningCount(): number {
  const { data: workspaces } = useListWorkspaces();
  const workspaceId = workspaces?.[0]?.id ?? '';
  const { data: runs } = useListWorkspaceFlowRuns(workspaceId, {
    query: {
      enabled: Boolean(workspaceId),
      throwOnError: false,
      refetchInterval: (query) =>
        query.state.data?.some(isOpen) ? BUSY_POLL_MS : IDLE_POLL_MS,
    },
  });
  return runs?.filter(isOpen).length ?? 0;
}
